import React from 'react';
import { doc, collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import MsgNetLoading from '../components/MsgNetLoading';
import ResultadoListTodos from '../components/ResultadoListTodos';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';
import SharePanel from '../components/SharePanel';
import TopHeaderMenu from '../components/TopHeaderMenu';
import { FirebaseContext } from '../index';

class TodosScreenClass extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            evento: null,
            competicion: null,
            sectores: [],
            controles: [],
            resultados: [],
            showSharePanel: false
        };
        this.unlisten = {};
    }

    toogleSharePanel() {
        this.setState(state => ({
            showSharePanel: !this.state.showSharePanel
        }));
    }

    // Helper: milisegundos desde medianoche -> moment
    parseMsToMoment(fechaYYYYMMDD, ms) {
        const base = moment(fechaYYYYMMDD, 'YYYY-MM-DD');
        if (!base.isValid()) return null;
        const n = Number(ms);
        return Number.isFinite(n)
            ? base.startOf('day').add(n, 'ms')
            : base;
    }

    // Calcular estado de la carrera (misma lógica que CompeticionList)
    getEstadoCarrera() {
        const { competicion } = this.state;
        if (!competicion) return null;

        // Fechas base
        const fechaInicio = competicion.fecha_inicio
            ? this.parseMsToMoment(competicion.fecha_inicio, competicion.hora_inicio ?? 0)
            : null;

        const fechaFin = competicion.fecha_inicio
            ? (competicion.hora_fin != null
                ? this.parseMsToMoment(competicion.fecha_inicio, competicion.hora_fin)
                : (fechaInicio ? moment(fechaInicio).endOf('day') : null))
            : null;

        const ahora = moment();
        const haEmpezado = fechaInicio ? ahora.isAfter(fechaInicio) : false;
        const pasoUnDiaDespues = fechaFin ? ahora.isAfter(moment(fechaFin).add(1, 'day')) : false;
        const haFinalizado = Boolean(competicion.carrera_finalizada) || pasoUnDiaDespues;

        return {
            haEmpezado,
            haFinalizado
        };
    }

    componentDidMount() {
        const { db, params } = this.props;
        const competicionId = parseInt(params.competicionId, 10);

        // Competición
        const competicionRef = doc(db, 'competicion', competicionId.toString());
        this.unlisten.competicion = onSnapshot(competicionRef, (snapshot) => {
            let competicion = snapshot.exists() ? snapshot.data() : null;
            if (competicion) competicion.id = snapshot.id;
            this.setState({ competicion });
        });

        // Controles
        const controlesQuery = query(
            collection(db, 'control'),
            where('competicion_id', '==', competicionId),
            where('visible', '==', true),
            orderBy('distancia', 'asc')
        );
        this.unlisten.controles = onSnapshot(controlesQuery, (snapshot) => {
            let controles = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            this.setState({ controles });
        });

        // Sectores
        const sectoresQuery = query(
            collection(db, 'sector'),
            where('competicion_id', '==', competicionId),
            orderBy('inicio', 'asc')
        );
        this.unlisten.sectores = onSnapshot(sectoresQuery, (snapshot) => {
            let sectores = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            this.setState({ sectores });
        });
    }

    // UNSAFE_componentWillUpdate(nextProps, nextState) {
    //     const { db, params } = this.props;

    //     if (this.state.controles !== nextState.controles && nextState.controles.length > 0) {
    //         const competicionId = parseInt(params.competicionId, 10);

    //         if (!this.unlisten.resultados) {
    //             const resultadosQuery = query(
    //                 collection(db, 'resultado'),
    //                 where('competicion_id', '==', competicionId)
    //             );
    //             this.unlisten.resultados = onSnapshot(resultadosQuery, (snapshot) => {
    //                 let resultados = snapshot.docs.map(doc => ({
    //                     id: doc.id,
    //                     ...doc.data()
    //                 }));
    //                 this.setState({ resultados });
    //             });
    //         }
    //     }

    //     if (this.state.competicion !== nextState.competicion && nextState.competicion) {
    //         const eventoId = nextState.competicion.evento_id;
    //         if (eventoId) {
    //             const eventoRef = doc(db, 'evento', String(eventoId));
    //             this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
    //                 let evento = snapshot.exists() ? snapshot.data() : null;
    //                 if (evento) evento.id = snapshot.id;
    //                 this.setState({ evento });
    //             });
    //         }
    //     }
    // }
    componentDidUpdate(prevProps, prevState) {
        const { db, params } = this.props;

        // Cargar resultados cuando llegan los controles
        if (prevState.controles !== this.state.controles && this.state.controles.length > 0) {
            const competicionId = parseInt(params.competicionId, 10);

            if (!this.unlisten.resultados) {
                const resultadosQuery = query(
                    collection(db, 'resultado'),
                    where('competicion_id', '==', competicionId)
                );
                this.unlisten.resultados = onSnapshot(resultadosQuery, (snapshot) => {
                    let resultados = snapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));
                    this.setState({ resultados });
                });
            }
        }

        // Cargar evento cuando se carga la competición
        if (prevState.competicion !== this.state.competicion && this.state.competicion) {
            const eventoId = this.state.competicion.evento_id;
            if (eventoId) {
                const eventoRef = doc(db, 'evento', String(eventoId));
                this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
                    let evento = snapshot.exists() ? snapshot.data() : null;
                    if (evento) evento.id = snapshot.id;
                    this.setState({ evento });
                });
            }
        }
    }

    componentWillUnmount() {
        if (this.unlisten.evento) this.unlisten.evento();
        if (this.unlisten.competicion) this.unlisten.competicion();
        if (this.unlisten.controles) this.unlisten.controles();
        if (this.unlisten.resultados) this.unlisten.resultados();
        if (this.unlisten.sectores) this.unlisten.sectores();
    }

    onClickBack() {
        this.props.navigate(`/${this.state.competicion.evento_id}`);
    }

    render() {
        const { evento, competicion, resultados, controles, sectores, showSharePanel } = this.state;

        if (!competicion) {
            return (
                <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-300">
                    <MsgNetLoading />
                </div>
            );
        }

        const estadoCarrera = this.getEstadoCarrera();

        // Determinar mensaje y estilo del banner
        let mensajeBanner = '';
        let claseBanner = 'ring-blue-500 text-white';

        if (estadoCarrera) {
            if (estadoCarrera.haFinalizado) {
                mensajeBanner = 'CARRERA FINALIZADA - Clasificación final';
                claseBanner = 'ring-slate-700 text-slate-300';
            } else if (estadoCarrera.haEmpezado) {
                mensajeBanner = 'CARRERA EN CURSO - Clasificación provisional basada en previsiones de llegada';
                claseBanner = 'ring-green-700 slate-300';
            } else {
                mensajeBanner = 'Listado de inscritos';
                claseBanner = 'ring-slate-700 text-slate-300';
            }
        }

        return (
            <div className="min-h-screen bg-gray-900 text-slate-100">
                <TopHeaderMenu
                    onClickBack={this.onClickBack.bind(this)}
                    onClickShare={this.toogleSharePanel.bind(this)}
                    competicion={competicion}
                    evento={evento}
                />

                <CompeticionHeaderMenu
                    competicion={competicion}
                    selected={6}
                    evento={evento}
                />

                {competicion.visible && (
                    <div className="mx-auto max-w-5xl md:px-12 mt-0 pt-28">

                        {/* Banner informativo con estado correcto */}
                        <div className="flex justify-center">
                            <div
                                className={[
                                    'w-fit rounded-lg px-4 py-2 mb-4 mx-4 text-sm font-light tracking-wide text-center',
                                    'ring-1 font-montserrat',
                                    claseBanner
                                ].join(' ')}
                            >
                                {mensajeBanner}
                            </div>
                        </div>

                        {/* Lista de resultados */}
                        <div>
                            {resultados.length > 0 && controles.length > 0 ? (
                                <ResultadoListTodos
                                    resultados={resultados}
                                    competicion={competicion}
                                    controles={controles}
                                    sectores={sectores}
                                />
                            ) : resultados.length > 0 ? (
                                // Si hay resultados pero no controles, mostrar igual (inscritos)
                                <ResultadoListTodos
                                    resultados={resultados}
                                    competicion={competicion}
                                    controles={[]}
                                    sectores={sectores}
                                />
                            ) : (
                                <div className="text-center py-8 text-gray-400">
                                    Cargando inscritos...
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {showSharePanel && (
                    <SharePanel
                        close={this.toogleSharePanel.bind(this)}
                        url={`/competicion/${competicion.id}/todos`}
                        title={`Todos los atletas en ${competicion.nombre} en ${evento ? evento.nombre : ''}`}
                    />
                )}
            </div>
        );
    }
}

// Wrapper funcional
function TodosScreen() {
    const navigate = useNavigate();
    const params = useParams();
    const { db } = React.useContext(FirebaseContext);

    return <TodosScreenClass navigate={navigate} params={params} db={db} />;
}

export default TodosScreen;